import { parseLocaleFromPathname } from "../../utils/localeUrl";

export const OPS_CONTACT_SOURCE = {
  INTERESTED: "interested",
  BUSINESS: "business",
};

export const OPS_CONTACT_SOURCE_LABELS = {
  [OPS_CONTACT_SOURCE.INTERESTED]: "מתעניין (מחוץ למערכת)",
  [OPS_CONTACT_SOURCE.BUSINESS]: "HotelsRiver Business",
};

/**
 * Resolve Ops contact source from route (Business portal vs general HotelsRiver).
 * @param {string} pathname
 * @returns {'interested' | 'business'}
 */
export function resolveOpsContactSourceChannel(pathname) {
  const { pathnameWithoutLocale } = parseLocaleFromPathname(pathname || "");
  const path = pathnameWithoutLocale || "";
  if (
    path === "/company" ||
    path.startsWith("/company/") ||
    path === "/p/company" ||
    path.startsWith("/p/company/") ||
    path === "/business" ||
    path.startsWith("/business/")
  ) {
    return OPS_CONTACT_SOURCE.BUSINESS;
  }
  return OPS_CONTACT_SOURCE.INTERESTED;
}

export function opsContactSourceLabel(channel) {
  return (
    OPS_CONTACT_SOURCE_LABELS[channel] ||
    OPS_CONTACT_SOURCE_LABELS[OPS_CONTACT_SOURCE.INTERESTED]
  );
}
